import { reportTemplateListSchema, reportTemplateSchema, } from '@consigli/types';
import { z } from 'zod';
import { createParams, createTransformer, mapToSnakeCase, } from './shared/base-api';
const uploadUrlResponseSchema = z.object({
    uploadUrl: z.string(),
    blobUrl: z.string(),
    blobName: z.string(),
});
const downloadUrlResponseSchema = z.object({
    downloadUrl: z.string(),
});
export const reportTemplateApiEndpoints = (builder, coreApiBaseUrl) => ({
    getReportTemplates: builder.query({
        query: ({ page, pageSize, report_type, project_type, location, search }) => {
            const params = createParams({
                page,
                page_size: pageSize,
                report_type,
                project_type,
                location,
                search,
            });
            return {
                url: `${coreApiBaseUrl}/report-generation-templates/`,
                method: 'GET',
                params: mapToSnakeCase(params),
            };
        },
        providesTags: ['ReportTemplate'],
        transformResponse: createTransformer(reportTemplateListSchema, 'getReportTemplates'),
    }),
    getReportTemplate: builder.query({
        query: ({ id }) => `${coreApiBaseUrl}/report-generation-templates/${id}/`,
        providesTags: ['ReportTemplate'],
        transformResponse: createTransformer(reportTemplateSchema, 'getReportTemplate'),
    }),
    createReportTemplate: builder.mutation({
        query: ({ payload }) => ({
            url: `${coreApiBaseUrl}/report-generation-templates/`,
            method: 'POST',
            body: mapToSnakeCase(payload),
        }),
        invalidatesTags: ['ReportTemplate'],
        transformResponse: createTransformer(reportTemplateSchema, 'createReportTemplate'),
    }),
    updateReportTemplate: builder.mutation({
        query: ({ id, data }) => ({
            url: `${coreApiBaseUrl}/report-generation-templates/${id}/`,
            method: 'PATCH',
            body: mapToSnakeCase(data),
        }),
        invalidatesTags: ['ReportTemplate'],
        transformResponse: createTransformer(reportTemplateSchema, 'updateReportTemplate'),
    }),
    deleteReportTemplate: builder.mutation({
        query: ({ id }) => ({
            url: `${coreApiBaseUrl}/report-generation-templates/${id}/`,
            method: 'DELETE',
        }),
        invalidatesTags: ['ReportTemplate'],
    }),
    getReportTemplateUploadUrl: builder.mutation({
        query: (payload) => ({
            url: `${coreApiBaseUrl}/report-generation-templates/upload-url/`,
            method: 'POST',
            body: mapToSnakeCase(payload),
        }),
        transformResponse: createTransformer(uploadUrlResponseSchema, 'getReportTemplateUploadUrl'),
    }),
    getReportTemplateOverwriteUrl: builder.mutation({
        query: ({ id }) => ({
            url: `${coreApiBaseUrl}/report-generation-templates/${id}/overwrite-url/`,
            method: 'POST',
        }),
        transformResponse: createTransformer(uploadUrlResponseSchema, 'getReportTemplateOverwriteUrl'),
    }),
    getReportTemplateDownloadUrl: builder.query({
        query: ({ id }) => `${coreApiBaseUrl}/report-generation-templates/${id}/download-url/`,
        transformResponse: createTransformer(downloadUrlResponseSchema, 'getReportTemplateDownloadUrl'),
    }),
});
